import Lenis from 'lenis';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';

gsap.registerPlugin(ScrollTrigger);

export const App = () => {
    document.addEventListener('DOMContentLoaded', () => {
        addVhToCss();
        addInViewClassOnScroll();
        addSwiper();
        addScrollToFirstSection();
        addExportCanvasWhilePressKey();
        addCursor();
        addGif();
    });
};



// Add vh to css
const addVhToCss = () => {
    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);

    window.addEventListener('resize', () => {
        vh = window.innerHeight * 0.01;
        document.documentElement.style.setProperty('--vh', `${vh}px`);
    });
}



// Add in-view class
const addInViewClassOnScroll = () => {


    const sections = document.querySelectorAll('section:not(:first-of-type)');    
    const config = {
        rootMargin: '0px',
        threshold: 0.5
    };

    const observer = new IntersectionObserver((entries, self) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                entry.target.classList.add('in-view');
                self.unobserve(entry.target);
            }
        });
    }, config);

    sections.forEach(section => {
        observer.observe(section);
    });

    // Initialize Lenis
    const lenis = new Lenis();
    lenis.on('scroll', () => {
        ScrollTrigger.update();
        observer.disconnect();
        sections.forEach(section => {
            observer.observe(section);
        });
    });

    gsap.ticker.add((time) => {
        lenis.raf(time * 1000);
    });

    gsap.ticker.lagSmoothing(0);
};


// Init Swiper carousel
const addSwiper = () => {
    const swiper = new Swiper('.swiper', {
        modules: [Navigation],
        loop: true,
        centeredSlides: true,
        slidesPerView: 1,
        spaceBetween: 0,
    
        preloadImages: false,
        lazy: true,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        on: {
            init: function() {
                // Initial legend text update
                const initialSlide = this.slides[this.activeIndex];
                setTimeout(() => {
                    const initialLegendText = initialSlide.querySelector('.slide__container').getAttribute('data-legend');
                    document.querySelector('.legend').textContent = initialLegendText;
                }, 1000);

            },
            slideChange: function() {
                const currentSlide = this.slides[this.activeIndex];
                const legendText = currentSlide.querySelector('.slide__container').getAttribute('data-legend');
                document.querySelector('.legend').textContent = legendText;
            }
        }
    });

    // Manually initialize Swiper to trigger the init event
    swiper.init();
};


// Scroll to first section

const addScrollToFirstSection = () => {

    const section = document.querySelector('section:nth-of-type(2)');
    const sectionOffset = section.offsetTop;

    const btn = document.querySelector('#enter');

    btn.addEventListener('click', () => {
        window.scrollTo({
            top: sectionOffset + 2,
            behavior: 'smooth'
        });
    });


}


// Press e to export image
const addExportCanvasWhilePressKey = () => {


    const download = document.querySelector('#download');

    window.addEventListener('keydown', (e) => {
        if (e.key === 'e') {
            const canvas = document.querySelector('canvas');
            const dataURL = canvas.toDataURL('image/png');
            const a = document.createElement('a');
            a.href = dataURL;
            a.download = 'HappyNewYear.png';
            a.click();
        }
    });
}


/* Custom lerp cursor*/

const addCursor = () => {
    let mouseX = window.innerWidth / 2;
    let mouseY = window.innerHeight / 2;
    let hasMoved = false;


    const circle = {
        el: document.getElementById('cursor'),
        x: window.innerWidth / 2,
        y: window.innerHeight / 2,
        w: 16,
        h: 16,
        update() {
            const l = this.x - this.w / 2;
            const t = this.y - this.h / 2;
            this.el.style.transform = `translate3d(${l}px, ${t}px, 0)`;
        }
    };

    window.addEventListener('mousemove', (e) => {
        mouseX = e.clientX;
        mouseY = e.clientY;

    // Make cursor visible on first move
    if (!hasMoved) {
        circle.el.style.opacity = 1;
        hasMoved = true;
    }
    });

    const move = () => {
        circle.x = lerp(circle.x, mouseX, 0.1);
        circle.y = lerp(circle.y, mouseY, 0.1);
        circle.update();
    };

    setInterval(move, 1000 / 60);

    const lerp = (start, end, amt) => {
        return (1 - amt) * start + amt * end;
    };

    // Add event listeners to links and buttons
    const interactiveElements = document.querySelectorAll('a, button, .swiper-button-next, .swiper-button-prev');
    interactiveElements.forEach(element => {
        element.addEventListener('mouseenter', () => {
            circle.el.querySelector('#dot').classList.add('big');
            circle.w = 100;
            circle.h = 100;
        });
        element.addEventListener('mouseleave', () => {
            circle.el.querySelector('#dot').classList.remove('big');
            circle.w = 16;
            circle.h = 16;
        });
    });
};


const addGif = () => {
    const images = document.querySelectorAll('.image__gif img');
    let currentIndex = 0;
    const delay = 1000;

        setInterval(() => {
            images[currentIndex].style.display = 'none';
            currentIndex = (currentIndex + 1) % images.length;
            images[currentIndex].style.display = 'block';
        }, delay);

};